/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-unused-vars */
import React, { useContext, useState, useEffect } from 'react';
import { Autocomplete, TextField, Box, Button } from '@mui/material';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import Grid from '@mui/material/Unstable_Grid2';
import moment from 'moment';
import { toast } from 'react-toastify';
// Helpers
import { filterTeamV4Options } from '../../../helpers/filterFunctions';
// API
import { getTeamV4Filter } from '../../../api/filterOptionsApi';
import { postProductSamplingProductList } from '../../../api/productSamplingDashboard';
// Context
import useProductSamplingContext from '../context/useProductSamplingContext';

export default function Filter() {
  const { filterForm, setFilterForm, handleGenerateFilter, handleClearFilter } =
    useContext(useProductSamplingContext);

  const [teamOptions, setTeamOptions] = useState([]);
  const [productOptions, setProductOptions] = useState([]);

  const loadTeamDropdown = async () => {
    const request = {
      date_from: moment(filterForm?.date_from).format('YYYY-MM-DD'),
      date_to: moment(filterForm?.date_to).format('YYYY-MM-DD'),
    };
    const reponse = await getTeamV4Filter(request);
    const { code, data } = reponse.data;
    if (code === '200') {
      const dropdownValue = filterTeamV4Options(data);
      setTeamOptions([{ label: 'ALL', value: null }, ...dropdownValue]);
    }
  };

  const loadProductDropdown = async () => {
    const request = {
      date_from: moment(filterForm?.date_from).format('YYYY-MM-DD'),
      date_to: moment(filterForm?.date_to).format('YYYY-MM-DD'),
    };
    const reponse = await postProductSamplingProductList(request);
    const { code, data } = reponse.data;
    if (code === '200') {
      const dropdownValue = data?.map((row) => ({
        value: row.product_id,
        label: row.product_name,
      }));
      setProductOptions([{ label: 'ALL', value: null }, ...dropdownValue]);
    }
  };

  const handleChangeDate = (value, name) => {
    if (name === 'date_from') {
      setFilterForm({
        ...filterForm,
        date_from: moment(value).format('YYYY-MM-DD'),
        date_to: moment(value).endOf('month').format('YYYY-MM-DD'),
      });
    }

    if (name === 'date_to') {
      if (moment(value).format('M') !== moment(filterForm?.date_from).format('M')) {
        toast.warning('Please select date with same month..');
        return;
      }
      setFilterForm({
        ...filterForm,
        date_to: moment(value).format('YYYY-MM-DD'),
      });
    }
  };

  const handleChangeFilter = (e, row, name) => {
    setFilterForm({ ...filterForm, [name]: row });
  };

  useEffect(() => {
    loadTeamDropdown();
    loadProductDropdown();
  }, [filterForm]);

  return (
    <Box>
      <Grid container spacing={2}>
        <Grid md={2}>
          <Autocomplete
            disablePortal
            id='team'
            disableClearable
            fullWidth
            options={teamOptions}
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(params) => <TextField {...params} label='Team' />}
            size='small'
            value={filterForm?.team}
            onChange={(e, newValue) => handleChangeFilter(e, newValue, 'team')}
            sx={{ backgroundColor: '#fff' }}
          />
        </Grid>
        <Grid md={2}>
          <Autocomplete
            id='product_id'
            multiple
            fullWidth
            options={productOptions}
            autoComplete
            includeInputInList
            filterSelectedOptions
            getOptionLabel={(option) => (option.label ? option.label : '')}
            value={filterForm.product_id}
            noOptionsText='No Products'
            onChange={(e, newValue) => {
              let updatedNewValue = newValue;

              if (newValue.length === 0) {
                // if remove all month option set default to all
                updatedNewValue = [productOptions[0]];
              } else if (newValue[newValue.length - 1].value === null) {
                // if last selected in ALL, remove all other options and retain ALL
                updatedNewValue = [productOptions[0]];
              } else if (newValue.length !== 1) {
                // if selected other months, remove ALL in selected options
                updatedNewValue = newValue.filter(
                  (option) => option.value !== productOptions[0].value,
                );
              }

              setFilterForm({
                ...filterForm,
                product_id: updatedNewValue,
              });
            }}
            isOptionEqualToValue={(option, selected) => option.value === selected.value}
            renderInput={(params) => <TextField {...params} label='Products' />}
            renderOption={(props, option) => (
              <li {...props} key={option.value}>
                {option.label}
              </li>
            )}
            size='small'
          />
        </Grid>
        <Grid md={1}>
          <DesktopDatePicker
            label='Date From'
            inputFormat='MM/DD/YYYY'
            value={filterForm.date_from}
            onChange={(e) => handleChangeDate(e, 'date_from')}
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(params) => <TextField size='small' {...params} />}
          />
        </Grid>
        <Grid md={1}>
          <DesktopDatePicker
            label='Date From'
            inputFormat='MM/DD/YYYY'
            value={filterForm?.date_to}
            onChange={(e) => handleChangeDate(e, 'date_to')}
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(params) => <TextField size='small' {...params} />}
          />
        </Grid>
        <Grid md={2}>
          <Button variant='contained' color='success' onClick={handleGenerateFilter}>
            Generate
          </Button>
          <Button
            variant='contained'
            color='primary'
            onClick={() => handleClearFilter()}
            sx={{ marginLeft: '10px' }}
          >
            Clear
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
}
